import React from 'react';
import { pdf } from '@react-pdf/renderer';
import ReportPdfDocument from '../pdf/ReportPdfDocument';
import buildReportFilename from './reportFilename';

/**
 * Generate and download a PDF report.
 * Uses File System Access API (Chrome/Edge) for save dialog with fallback.
 */
const exportReportPdf = async ({
  config,
  columns,
  columnWidths,
  data,
  parameters,
  logoSrc,
  onProgress
}) => {
  try {
    if (onProgress) onProgress('Generating PDF...');

    const doc = (
      <ReportPdfDocument
        config={config}
        columns={columns}
        columnWidths={columnWidths}
        data={data}
        parameters={parameters}
        logoSrc={logoSrc}
      />
    );

    const blob = await pdf(doc).toBlob();

    const filename = buildReportFilename(config.reportName, 'pdf');

    // Try File System Access API (Chrome/Edge save dialog)
    if (window.showSaveFilePicker) {
      try {
        const handle = await window.showSaveFilePicker({
          suggestedName: filename,
          types: [{
            description: 'PDF Document',
            accept: { 'application/pdf': ['.pdf'] }
          }]
        });
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        if (onProgress) onProgress(null);
        return true;
      } catch (err) {
        if (err.name === 'AbortError') {
          if (onProgress) onProgress(null);
          return false; // User cancelled
        }
        // Fall through to blob download
      }
    }

    // Fallback: blob URL click-to-download
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    if (onProgress) onProgress(null);
    return true;
  } catch (err) {
    if (onProgress) onProgress(null);
    throw err;
  }
};

export default exportReportPdf;
